import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {
  NotificationMessage,
  NotificationMessageType,
  NOTIFICATION_MESSAGE_INFO,
} from '../models/notification-message.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationMessagesService {
  private messageSubject: Subject<NotificationMessage> = new Subject<NotificationMessage>();

  /**
   * Flujo observable de mensajes de notificación.
   * Los componentes pueden suscribirse a este para recibir los mensajes.
   */
  private _messages$: Observable<NotificationMessage>;
  public get messages$(): Observable<NotificationMessage> {
    if (!this._messages$) {
      this._messages$ = this.messageSubject.asObservable();
    }
    return this._messages$;
  }

  constructor() {
  }

  /**
   * Añade un nuevo mensaje para ser mostrado.
   *
   * @param text El texto del mensaje a mostrar.
   * @param type El tipo de mensaje (p. ej., 'info', 'success', 'error').
   */
  public addMessage(
    text: string,
    type: NotificationMessageType = NOTIFICATION_MESSAGE_INFO
  ): void {
    this.messageSubject.next({ text, type });
  }

  /**
   * Clears the current messages by emitting a null value.
   * This method is typically used to reset or clear the current message state.
   *
   * @return {void} Does not return a value.
   */
  clearMessages() {
    // Solo emitimos null para limpiar los mensajes actuales
    this.messageSubject.next(null);
  }
}
